import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal, onlyNumberWithTwoDecimal, onlyNumberWithTwoDecimalNegative } from '../../../components/functions'
import InputMask from 'react-input-mask'
import { useGeradoresEstacionariosContext } from '../../../context/geradoresEstacionariosContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { setAtualizacaoGestao } = useTabelaGestao()

    const { energiaGerador_id, setEnergiaGerador_id } = useGeradoresEstacionariosContext()


    const [resultadoGeradores, setResultadoGeradores] = useState([])
    const [resultadoMarca, setResultadoMarca] = useState([])

    const [listaAnos, setListaAnos] = useState()
    const [anoFabricacao, setAnoFabricacao] = useState()
    const [quantidade, setQuantidade] = useState('')
    const [aquisicao, setAquisicao] = useState('')


    const [energiaGeradorMarca_id, setEnergiaGeradorMarca_id] = useState('')
    const [modeloGerador, setModeloGerador] = useState('')
    const [potenciaNominal, setPotenciaNominal] = useState('')
    const [percentualCarga, setPercentualCarga] = useState('')
    const [fonteEnergetica, setFonteEnergica] = useState('')
    const [rede, setRede] = useState('')
    const [tipoUso, setTipoUso] = useState('')
    const [aplicacao, setAplicacao] = useState('')
    const [rotinaManutencao, setRotinaManutencao] = useState('')
    const [funcionamento, setFuncionamento] = useState('')
    const [entradaOperacao, setEntradaOperacao] = useState('')
    const [saidaOperacao, setSaidaOperacao] = useState('')

    



    const carregaMarcas = () => {

        //console.log('aqui')

        api.get('energiaGeradorMarca').then((result) => {

            //console.log(result.data, 'marcas')
            setResultadoMarca(result.data.map((rs) => 
            
                <option value={rs.energiaGeradorMarca_id}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }

    const handleChange = (e) => {
        e.preventDefault();
    }



    const carregaGerador = () => {

        //console.log('aqui!!')
        if (energiaGerador_id) {

            api.get(`energiaGeradorListaUm/${energiaGerador_id}`).then((result) => {

                var data = result.data[0]
                
                //setEnergiaGerador_id(data.energiaGerador_id)
                setAnoFabricacao(data.anoFabricacao)
                setEnergiaGeradorMarca_id(data.energiaGeradorMarca_id)
                setModeloGerador(data.modeloGerador)
                setQuantidade(data.quantidade)
                setPotenciaNominal(data.potenciaNominal)
                setAquisicao(data.aquisicao)
                setFonteEnergica(data.fonteEnergetica)
                setRede(data.rede)
                setPercentualCarga(data.percentualCarga)
                setTipoUso(data.tipoUso)
                setAplicacao(data.aplicacao)
                setRotinaManutencao(data.rotinaManutencao)
                setFuncionamento(data.funcionamento)
                setEntradaOperacao(data.entradaOperacao)
                setSaidaOperacao(data.saidaOperacao)

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    const limpa = () => {


        //setEnergiaGerador_id()
        setAnoFabricacao('')
        setEnergiaGeradorMarca_id('')
        setModeloGerador('')
        setQuantidade('')
        setPotenciaNominal('')
        setAquisicao('')
        setFonteEnergica('')
        setRede('')
        setPercentualCarga('')
        setTipoUso('')
        setAplicacao('')
        setRotinaManutencao('')
        setFuncionamento('')
        setEntradaOperacao('')
        setSaidaOperacao('')

    }





    const salva = () => {

        /*

        energia_id: Joi.number().integer().required(),
        adesao_institucional_id: Joi.number().integer().required(),
        ano: Joi.number().integer().required(),
        geradorMarca_id: Joi.number().integer().required(),
        modeloGerador: Joi.string().max(250).allow(null), // Optional field
        anoFabricacao: Joi.number().integer().required(),
        quantidade: Joi.number().integer().required(),
        aquisicao: Joi.string().max(50).allow(null), // Optional field
        potenciaNominal: Joi.number().required(),
        percentualCarga: Joi.number().allow(null), // Optional field
        fonteEnergetica_id: Joi.number().integer().required(),
        rede_id: Joi.number().integer().allow(null), // Optional field
        tipoUso_id: Joi.number().integer().allow(null), // Optional field
        aplicacao_id: Joi.number().integer().allow(null), // Optional field
        rotinaManutencao_id: Joi.number().integer().required(),
        funcionamento: Joi.string().max(50).required(),
        entradaOperacao: Joi.date().iso().allow(null), // Optional field
        saidaOperacao: Joi.date().iso().allow(null), // Optional field

        */

        if (energiaGeradorMarca_id == '') {

            window.toastr.error('<b>Marca do Gerador</b> não pode ficar em branco!')
            return false

        }

        if (fonteEnergetica == '') {

            window.toastr.error('<b>Fonte Energética</b> não pode ficar em branco!')
            return false

        }

        if (rotinaManutencao == '') {

            window.toastr.error('<b>Rotina de Manutenção</b> não pode ficar em branco!')
            return false

        }

        if (funcionamento == '') {

            window.toastr.error('<b>Funcionamento</b> não pode ficar em branco!')
            return false            
        }


        if (anoFabricacao == '') {

            window.toastr.error('<b>Ano de Fabricação</b> não pode ficar em branco!')
            return false

        }

        if (quantidade == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        } else {

            if (quantidade == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false

            }

        }


        if (entradaOperacao != '') {


            if (entradaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacao.split('/')
                var mesEntradaOperacao = x_array[0]

                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacao != '') {


            if (saidaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacao.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }


        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            energiaGeradorMarca_id: energiaGeradorMarca_id,
            modeloGerador: modeloGerador,
            anoFabricacao: anoFabricacao,
            quantidade: quantidade,
            aquisicao: aquisicao,
            potenciaNominal: potenciaNominal,
            percentualCarga: percentualCarga,
            fonteEnergetica: fonteEnergetica,
            rede: rede,
            tipoUso: tipoUso,
            aplicacao: aplicacao,
            rotinaManutencao: rotinaManutencao,
            funcionamento: funcionamento,
            entradaOperacao: entradaOperacao,
            saidaOperacao: saidaOperacao,
            
        }

        //console.log(dataPost)
        //return false


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                            
                    if (energiaGerador_id) {

                        api.put(`energiaGerador/${energiaGerador_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //setShow(false)
                            window.$('#modalGeradorEstacionario').modal('hide')
                            //props.consultaGeradores()
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {


                        api.post('energiaGerador', dataPost).then((result) => {

                            //console.log(result.data)
                            //setShow(false)
                            window.$('#modalGeradorEstacionario').modal('hide')
                            //consultaGeradores()
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')

                        }).catch((err) => {

                            console.log(err.response)

                        })


                    }
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }






    const apagaGerador = () => {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar?',
		    buttons: {
		        Sim: function () {



                    api.delete(`energiaGerador/${energiaGerador_id}`).then((result) => {

                        //setShow(false)
                        window.$('#modalGeradorEstacionario').modal('hide')
                        //consultaGeradores()
                        setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                        window.toastr.success('Registro apagado com sucesso!')

                    }).catch((err) => {

                        console.log(err.response)

                    })
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }



    useEffect(() => {

        limpa()
        carregaGerador()

        console.log(energiaGerador_id, 'a!!')

    }, [energiaGerador_id])


    useEffect(() => {

        carregaMarcas()
        carregaAnos()

    }, [])


    useEffect(() => {

        limpa()
        //consultaGeradores()
        //consultaInforma()

    }, [ano, energia_id])


    return (

        <div>

                <div className="modal fade" id="modalGeradorEstacionario" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Geradores Estacionários</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">


                                
                                <div className="col-md-12" >
                                        <b>Dados básicos</b>
                                        <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Marca do Gerador *</label>
                                            <select class="form-control" value={energiaGeradorMarca_id} onChange={event => setEnergiaGeradorMarca_id(event.target.value)}>
                                               <option value="">[Selecione]</option>
                                               {resultadoMarca}

                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Modelo do gerador</label>
                                            <input class="form-control" value={modeloGerador}  onChange={event => setModeloGerador(event.target.value)} style={{ 'text-transform': 'uppercase'}} />
                                               
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Ano de Fabricação *</label>
                                            <select class="form-control" value={anoFabricacao} onChange={event => setAnoFabricacao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {listaAnos}
                                                <option value="0">Não informado</option>
                                            </select>
                                               
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        <br/>
                                            <label className="control-label">Quantidade *</label>
                                            <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                                }
                                            }} 
                                            />
                                                
                                        </div>
                                    </div>


                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        <br/>
                                            <label className="control-label">Aquisição</label>
                                            <select class="form-control" value={aquisicao} onChange={event => setAquisicao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Compra">Compra</option>
                                                <option value="Aluguel">Aluguel</option>
                                            </select>
                                                
                                        </div>
                                    </div>

                                
                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência nominal [kVA]</label>
                                            <input class="form-control" value={potenciaNominal} onChange={event => setPotenciaNominal(event.target.value)}/>
                                               
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Percentual médio de carga (%)</label>
                                            <input class="form-control" value={percentualCarga} onChange={event => setPercentualCarga(event.target.value)} />
                                               
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Fonte energética *</label>
                                            <select class="form-control" value={fonteEnergetica} onChange={event => setFonteEnergica(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value="Etanol Hidratado">Etanol Hidratado</option>
                                                <option value="Gás Natural Seco">Gás Natural Seco</option>
                                                <option value="Gasolina Comum (tipo C)">Gasolina Comum (tipo C)</option>
                                                <option value="Gasolina Pura (tipo A)">Gasolina Pura (tipo A)</option>
                                                <option value="Gás Liquefeito de Petróleo (GLP)">Gás Liquefeito de Petróleo (GLP)</option>
                                                <option value="Óleo Combustível">Óleo Combustível</option>
                                                <option value="Óleo de Xisto">Óleo de Xisto</option>
                                                <option value="Óleo Diesel (Comercial)">Óleo Diesel (Comercial)</option>
                                                <option value="Lenha (Comercial)">Lenha (Comercial)</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        <br/>
                                            <label className="control-label">Rede</label>
                                            <select class="form-control" value={rede} onChange={event => setRede(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value="Contínua">Contínua</option>
                                                <option value="Monofásica">Monofásica</option>
                                                <option value="Bifásica">Bifásica</option>
                                                <option value="Trifásica">Trifásica</option>
                                            </select>
                                                
                                        </div>
                                    </div>

                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Operacionais</b>
                                    <br/><br/>
                                </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Tipo de uso</label>
                                            <select class="form-control" value={tipoUso} onChange={event => setTipoUso(event.target.value)}  >
                                                <option value="">[Selecione]</option>
                                                <option value="Contínuo">Contínuo</option>
                                                <option value="Stand-by">Stand-by</option>
                                                <option value="Prime">Prime</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Aplicação</label>
                                            <select class="form-control" value={aplicacao} onChange={event => setAplicacao(event.target.value)}  >
                                                <option value="">[Selecione]</option>
                                                <option value="Emergência">Emergência</option>
                                                <option value="Exigência Legal">Exigência Legal</option>
                                                <option value="Opcional">Opcional</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Rotina de Manutenção *</label>
                                            <select class="form-control" value={rotinaManutencao} onChange={event => setRotinaManutencao(event.target.value)}  >
                                                <option value="">[Selecione]</option>
                                                <option value="Periódica Semanal">Periódica Semanal</option>
                                                <option value="Periódica Mensal">Periódica Mensal</option>
                                                <option value="Periódica Anual">Periódica Anual</option>
                                                <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>


                                    <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [horas/ano] *</label>
                                                <input class="form-control" input="text"  
                                                value={funcionamento} onChange={event => setFuncionamento(event.target.value)} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Entrada em operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                        </div>
                                                    </span>

                                                </label>

                                                
                                                <InputMask mask="99/9999" class="form-control" value={entradaOperacao} onChange={event => setEntradaOperacao(event.target.value)}  />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Saída de operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        Insira a data (mês e ano) quando o equipamento saiu de operação na unidade. Deixar em branco caso ainda esteja em operação.


                                                        </div>
                                                    </span>

                                                </label>
                                                
                                                <InputMask mask="99/9999" class="form-control" value={saidaOperacao} onChange={event => setSaidaOperacao(event.target.value)}  />
                                                    
                                            </div>
                                        </div>





                            </div>



                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-danger" onClick={() => apagaGerador()} style={{ display: energiaGerador_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>


                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal